/**
 * Utility functions for OS detection and keyboard shortcut formatting
 */

/**
 * Detect if the user is on macOS
 * @returns true if on macOS, false otherwise
 */
export const isMac = (): boolean => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return false;
    }

    return (
        navigator.platform.toUpperCase().indexOf('MAC') >= 0 ||
        navigator.userAgent.toUpperCase().indexOf('MAC') >= 0
    );
};

/**
 * Get the appropriate modifier key symbol for the current OS
 * @returns '⌘' for Mac, 'Ctrl' for Windows/Linux
 */
export const getModifierKey = (): string => {
    return isMac() ? '⌘' : 'Ctrl';
};

/**
 * Get the appropriate modifier key + K shortcut for the current OS
 * @returns '⌘K' for Mac, 'Ctrl+K' for Windows/Linux
 */
export const getCommandPaletteShortcut = (): string => {
    return isMac() ? '⌘K' : 'Ctrl+K';
};

/**
 * Format a keyboard shortcut for display based on the current OS
 * @param keys - Array of keys in the shortcut (e.g., ['cmd', 'shift', 'u'])
 * @returns Formatted shortcut string (e.g., '⌘⇧U' or 'Ctrl+Shift+U')
 */
export const formatShortcut = (keys: string[]): string => {
    const mac = isMac();

    const keyMap: { [key: string]: { mac: string; other: string } } = {
        cmd: { mac: '⌘', other: 'Ctrl' },
        ctrl: { mac: '⌃', other: 'Ctrl' },
        shift: { mac: '⇧', other: 'Shift' },
        alt: { mac: '⌥', other: 'Alt' },
        option: { mac: '⌥', other: 'Alt' },
    };

    const separator = mac ? '' : '+';

    return keys
        .map(key => {
            const normalized = key.toLowerCase();
            if (keyMap[normalized]) {
                return mac ? keyMap[normalized].mac : keyMap[normalized].other;
            }
            return key.toUpperCase();
        })
        .join(separator);
};








